export default[
    {
        path: '/carta/demissao/cadastro',
        name: 'cadastro da carta demissão', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/carta/demissao/lista',
        name: 'lista da carta demissão', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/carta/demissao/editar/:id',
        name: 'editar carta demissão', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]